import { SetEmailWhitelist } from 'domain/usecases/email-whitelist';
import { HttpClient } from 'data/protocols/http';
import { makeApiUrl } from 'main/factories/http';

export class RemoteSetEmailWhitelist implements SetEmailWhitelist {
  constructor(private readonly httpClient: HttpClient) {}

  async set(params: SetEmailWhitelist.Params): Promise<SetEmailWhitelist.Model> {
    const requestUrl = makeApiUrl(`/emails/locations/${params.locationId}/whitelist`);

    const response = await this.httpClient.request({
      method: 'post',
      url: requestUrl,
      body: params.payload,
    });

    return response.body;
  }
}
